import React, { FC } from 'react'

import { LocationDto } from '@apiModels/LocationDto.csharp';

import { useInsuranceFilters } from '../Utils/Context/filtersContext';
import { addOrRemoveItemInArray } from '../Utils/addOrRemoveItemInArray';

import { Keyword } from '../Partials/Keyword';
import { List } from '../Partials/List';

export const LocationsList: FC<{}> = () => {

  const {
    locations,
    setLocations,
  } = useInsuranceFilters();

  const renderSelectedLocations = (location: LocationDto) => {
    const newLocations = locations 
      ? addOrRemoveItemInArray(locations, location)
      : []

    return (
      <li key={`${location.id}`}>
        <Keyword
          isSelected
          label={location.name}
          onClick={() => setLocations(newLocations)}
        />
      </li>
    )
  }

  if (!locations) return <></>
  return (
    <List<LocationDto>
      items={locations}
      renderItem={renderSelectedLocations}
      useDefaultLayout={false}
      listClassName="locationsList"
    />
  )
};
